<!-- @veltra/icons generated sha256:3b7b1cccf1f66ad0 gen:8 source:src/svg/normal/zoom-in.svg -->
<script setup lang="ts">
defineOptions({ name: 'ZoomIn' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35M11 8v6m-3-3h6" />
  </svg>
</template>
